export type { RemoveTypenameFromVariablesOptions } from "./removeTypenameFromVariables.js";
export {
  removeTypenameFromVariables,
  KEEP,
} from "./removeTypenameFromVariables.js";
